import { useEffect, useRef, useState } from 'react'
import T from 'prop-types'

function ScaleToFit({ children }) {
  const outerRef = useRef(null)
  const innerRef = useRef(null)
  const [outerHeight, setOuterHeight] = useState('auto')

  useEffect(() => {
    const outer = outerRef.current
    const inner = innerRef.current
    if (!outer || !inner) return

    const update = () => {
      const availableWidth = outer.offsetWidth
      const naturalWidth = inner.scrollWidth
      const naturalHeight = inner.scrollHeight

      if (naturalWidth <= availableWidth) {
        inner.style.transform = ''
        setOuterHeight('auto')
        return
      }

      const scale = availableWidth / naturalWidth
      inner.style.transform = `scale(${scale})`
      inner.style.transformOrigin = 'center top'
      setOuterHeight(naturalHeight * scale)
    }

    const ro = new ResizeObserver(update)
    ro.observe(outer)
    update()
    return () => ro.disconnect()
  }, [])

  return (
    <div ref={outerRef} style={{ height: outerHeight }} className="flex justify-center overflow-hidden w-full">
      <div ref={innerRef} className="flex-shrink-0">
        {children}
      </div>
    </div>
  )
}

ScaleToFit.propTypes = { children: T.node.isRequired }

export default ScaleToFit
